export default __webpack_public_path__ + "static/media/ucla-logo.0cbcea1e.jpg";